import type { JSX } from 'react';
import Box from 'carbon-react/esm/components/box';
import Typography from 'carbon-react/esm/components/typography';

const Footer = (): JSX.Element => {
  const currentYear = new Date().getFullYear();
  const gitSha = import.meta.env.VITE_GIT_SHA;

  return (
    <Box
      as="footer"
      display="flex"
      justifyContent="space-between"
      flexDirection="row"
      alignItems="center"
      width="auto"
      p={2}
    >
      <Box flex="1"></Box>

      <Typography variant="span">© {currentYear} Sage. Tous droits réservés.</Typography>

      <Box flex="1" display="flex" justifyContent="flex-end">
        <Typography as="code" variant="small" size="M" whiteSpace="pre-wrap">
          {gitSha && <span>{`[${gitSha}]`}</span>}
        </Typography>
      </Box>
    </Box>
  );
};

export default Footer;
